import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SinControllerDirective } from './directive/sin-controller.directive';

@NgModule({
  declarations: [SinControllerDirective],
  imports: [
    CommonModule
  ],
  exports: [SinControllerDirective]
})
export class SinControllerModule { }
